import { DemoManifest } from './types';
import { nespressoDemo } from './nespresso';

// Demo registry - all available demos
// Isolated demos have their own context/components in src/demos/[name]/
// Legacy demos use shared views in src/components/views/

// Isolated demos - fully self-contained modules
const isolatedDemos: DemoManifest[] = [
  nespressoDemo,
];

// Legacy demos - use shared component architecture
const legacyDemos: DemoManifest[] = [
  {
    id: 'adidas',
    name: 'Adidas',
    description: 'Sneaker takeback program',
    logo: '/assets/images/logos/adidas.png',
    color: '#000000',
    features: {
      loyalty: true,
      cashRewards: true,
      discountCoupons: true,
    },
  },
  {
    id: 'nike',
    name: 'Nike',
    description: 'Footwear recycling initiative',
    logo: '/nike-swoosh.png',
    color: '#111111',
    features: {
      loyalty: true,
      cashRewards: true,
      discountCoupons: true,
    },
  },
  {
    id: 'lululemon',
    name: 'Lululemon',
    description: 'Athletic wear trade-in',
    logo: '/assets/images/logos/lululemon.svg',
    color: '#D31334',
    features: {
      loyalty: true,
      cashRewards: true,
      discountCoupons: true,
    },
  },
  {
    id: 'kiehls',
    name: "Kiehl's",
    description: 'Beauty packaging returns',
    logo: '/assets/images/logos/kiehls.png',
    color: '#1a1a1a',
    features: {
      loyalty: true,
      cashRewards: false,
      discountCoupons: true,
      aiVision: true,
    },
  },
  {
    id: 'demobrand',
    name: 'Demo Brand',
    description: 'Generic demo template',
    logo: '/assets/images/logos/demobrand.svg',
    color: '#4F46E5',
    features: {
      loyalty: true,
      cashRewards: true,
      discountCoupons: true,
    },
  },
];

// Combine all demos
export const demos: DemoManifest[] = [...isolatedDemos, ...legacyDemos];

export const getDemoById = (id: string): DemoManifest | undefined =>
  demos.find(d => d.id === id);

export const getAllDemos = (): DemoManifest[] => demos;

export const isLegacyDemo = (id: string): boolean =>
  legacyDemos.some(d => d.id === id);

export const isIsolatedDemo = (id: string): boolean =>
  isolatedDemos.some(d => d.id === id);
